import React from 'react';
import TermsConditions from './termsCondition';
import TermsConditionsOther from './termsConditionsOther';
import { Link } from 'react-router-dom';
interface Props {
  setOpenTCModal: any;
  doMonerisSubmit: any;
}
function TCModal({ setOpenTCModal, doMonerisSubmit }: Props) {
  return (
    <div
      className='modal fade show'
      id='t_and_c_modal'
      tabIndex={-1}
      role='dialog'
      aria-labelledby='TermsAndConditionsModalLabel'
      style={{ display: 'block' }}
    >
      <div
        className='modal-dialog modal-dialog-centered modal-xl'
        role='document'
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h3 className='col-12 ubbe-blue fw-bold text-center mt-3'>
              Terms & Conditions
            </h3>
          </div>
          <div className='modal-body p-4 m-4'>
            <div style={{ overflow: 'auto', height: '400px' }}>
              <TermsConditions />
              <TermsConditionsOther />
            </div>

            <p className='mt-4 px-1'>
              By clicking, you agree to bbe's{' '}
              <Link target='_blank' to={`${process.env.REACT_APP_TERMS_URL}`}>
                Terms & Conditions
              </Link>{' '}
              and{' '}
              <Link to={`${process.env.REACT_APP_PRIVACY_URL}`} target='_blank'>
                Privacy Policy
              </Link>
              .
            </p>
            <div className='d-flex justify-content-between  pt-4'>
              <div>
                <div
                  className='btn btn-ubbe-new-back d-flex gap-2'
                  onClick={() => {
                    setOpenTCModal(false);
                  }}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='15'
                    height='8'
                    viewBox='0 0 15 8'
                    fill='none'
                  >
                    <path
                      d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                      fill='black'
                    />
                  </svg>
                  Back
                </div>
              </div>
              <div>
                <button
                  className='btn-ubbe-new-blue  justify-content-end '
                  id='next_account'
                  onClick={() => {
                    doMonerisSubmit();
                    setOpenTCModal(false);
                  }}
                  style={{ maxWidth: '145px' }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TCModal;
